import Modal from 'react-bootstrap/Modal'
import {Button} from 'react-bootstrap'
import {Form} from 'react-bootstrap'
import { useState } from 'react';
import { addApplication } from '../../http/applicationsAPI';


function ApplicationModal({show,onHide}) {
    const [phone, setPhone] = useState('');
    const [email,setEmail] = useState('')
    const [name,setName] = useState('')
    const [text,setText] = useState('')

    const PATTERN = /\D/g;

    const getOnlyNumbers = (value) =>{
      return value.replace(PATTERN, "")
    }

    const handleChange = (e) => {
      const inp = e.target
      let currentValues = getOnlyNumbers(inp.value)
      if(!currentValues){
        return (inp.value = "")
      }
      if (["7", "8"].indexOf(currentValues[0]) !== -1) {
      }
      const firstSymbols = currentValues[0] === "8" ? "8" : "+7"
      let formattedNumbers = firstSymbols + " "
      if(currentValues.length > 1){
        formattedNumbers += '(' + currentValues.substring(1,4)
      }
      if(currentValues.length >= 5){
        formattedNumbers += ')' + currentValues.substring(4,7)
      }
      if(currentValues.length >= 8){
        formattedNumbers += '-' + currentValues.substring(7,9)
      }
      if(currentValues.length >= 10){
        formattedNumbers += '-' + currentValues.substring(9,11)
      }else{
        formattedNumbers = "+" + currentValues.substring(0,16)
      }
      setPhone(formattedNumbers)
      }


    const handleSubmit = async () =>{
        try {
            if(!phone || !email || !name || !text){
            alert('Пожалуйста, заполните все поля')
            return
          }
            await addApplication(email,phone,name,text)
            alert('Заявка успешно отправлена')
            onHide()
        } catch (error) {
            console.log(error)
        }
    }
  return (
  <Modal
        show={show}
        onHide={onHide}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter" style={{fontFamily:'BD',color:'#404040'}}>
            Заявка
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form>
                <Form.Control 
                    placeholder='Введите почту (email@example.com)'
                    style={{marginTop:'2%'}}
                    autoComplete='true'
                    type='email'
                    value={email}
                    onChange={e => setEmail(e.target.value)} 
                />
                <Form.Control
                    placeholder='+7 ___ ___-__-__'
                    value={phone}
                    onChange={handleChange}
                    style={{ marginTop: '2%' }}
                    type='tel'
                    autoComplete='off'
                    maxLength={18}
                    inputMode='numeric'/>
                <Form.Control 
                    placeholder='Имя'
                    style={{marginTop:'2%'}}
                    value={name}
                    onChange={e => setName(e.target.value)}/>
                <Form.Control 
                    placeholder='Что вы хотите узнать?' 
                    style={{marginTop:'2%'}}
                    value={text}
                    onChange={e => setText(e.target.value)} />
            </Form>
        </Modal.Body>
        <Modal.Footer>
        <Button className='blue-btn' onClick={handleSubmit}>Оставить заявку</Button>
        </Modal.Footer>
      </Modal>
  );
}

export default ApplicationModal;